module.exports = __webpack_public_path__ + "static/spotify-6ba81aa47da7873ee347901379a256c9.jpg";